<div class="popover-overlay" *ngIf="visible" (click)="close()">
  <div class="popover-content" (click)="$event.stopPropagation()">
    <div class="popover-header">
      <div class="popover-title popover-title-font"></div>
      <button class="close-btn" (click)="close()">
        <img [src]="'../../../../assets/svg/fechar_search.svg'" />
      </button>
    </div>

    <div class="popover-body">
      <bfd-icon [typeIcon]="iconInput.type" [typeColor]="iconInput.typeColor" [img]="iconInput.img" [size]="iconInput.size"></bfd-icon>
      <p class="title mt-2">{{ title }} 
        <span *ngIf="alertBadge" class="badge">{{ alertBadge }}</span></p>
      <p *ngIf="subtitle" class="sub-title">
        {{ subtitle }}
      </p>

      <ng-container *ngIf="view === 'fibra-facil'">
        <div *ngIf="true">
          <p class="text-base">
            Para saber mais sobre o seu limite indisponível, entre em contato com seu gerente, ou com a nossa equipe de atendimento pelos contatos abaixo.
          </p>
          <div class="d-flex flex-column mt-2">
            <span class="span-value-blocked">Corporate, Agro, Middle e PMEs</span>
            <span class="span-description-blocked">(11) 4130-7449</span>
            <a class="span-description-blocked" href="mailto:relacionamento@bancofibra.com.br">relacionamento@bancofibra.com.br</a>
            <p class="p-description-blocked">Horário: 9h às 18h, de segunda a sexta-feira, exceto feriados.</p>
          </div>
        </div>

        <div *ngIf="false">
          <p class="text-base">
            Encargos serão debitados no <strong>primeiro dia útil de cada mês.</strong>
          </p>
          <div class="d-flex flex-column mb-3">
            <span class="span-description">Previsão de encargos</span>
            <span class="span-value">R$ 413,00</span>
          </div>
          <p class="p-description-blocked">Previsão de encargos até: 01/05/2025</p>
        </div>
        <div *ngIf="false">
          <p class="text-base">
            Ao utilizar seu Limite Fibra Fácil, juros e IOF podem ser debitados de sua conta em datas diferentes.
          </p>
          <div class="d-flex flex-column mb-3">
            <span class="span-description">Limite total</span>
            <span class="span-value">R$ 10.000,00</span>
          </div>
          <div class="d-flex justify-content-between">
            <div class="d-flex flex-column">
              <span class="span-description">Em uso</span>
              <span class="span-value">R$ 5.000,00</span>
            </div>
            <div class="d-flex flex-column align-items-end">
              <span class="span-description">Em uso por</span>
              <span class="span-value">06 dias</span>
            </div>
          </div>
          <bfd-divider [type]="'line'" [padding]="'medium'"></bfd-divider>
          <div class="d-flex justify-content-between mb-3">
            <div class="d-flex flex-column">
              <span class="span-description">Juros</span>
              <span class="span-value">R$ 10,00</span>
            </div>
            <div class="d-flex flex-column align-items-end">
              <span class="span-description">Data do débito</span>
              <span class="span-value">04/09/2025</span>
            </div>
          </div>
          <div class="d-flex justify-content-between mb-3">
            <div class="d-flex flex-column">
              <span class="span-description">IOF</span>
              <span class="span-value">R$ 5,00</span>
            </div>
            <div class="d-flex flex-column align-items-end">
              <span class="span-description">Data do débito</span>
              <span class="span-value">2º dia útil do mês</span>
            </div>
          </div>
          <div class="d-flex flex-column mb-3">
            <span class="span-description">Previsão total de encargos</span>
            <span class="span-value">- R$ 10.000,00</span>
          </div>
          <div class="d-flex flex-column mb-3">
            <span class="span-description color-gray"
              >Atualizado: 20/03/2025</span
            >
          </div>
          <bfd-divider [type]="'line'" [padding]="'medium'"></bfd-divider>
          <p class="text-base">
            {{ description }}
          </p>
        </div>

        <div *ngIf="false">
          <div class="d-flex flex-column mb-3">
            <span class="span-description">Limite total</span>
            <span class="span-value">R$ 10.000,00</span>
          </div>
          <div class="d-flex flex-column mb-3">
            <span class="span-description">Em uso</span>
            <span class="span-value">R$ 0,00</span>
          </div>
        </div>

        <div *ngIf="false" class="button-list-cards">
          <button class="card-button" (click)="limitSimulator()">
            <img [src]="'../../../../assets/svg/extract.svg'" />
            <span>Simular uso</span>
          </button>
          <button class="card-button" (click)="encreaseLimit()">
            <img [src]="'../../../../assets/svg/extract.svg'" />
            <span>Solicitar aumento de limite</span>
          </button>
        </div>
      </ng-container>
      <ng-container *ngIf="view === 'limit-increase' || view === 'limit-increase-result'">
        <p class="text-base">
          {{ view === 'limit-increase' ? 
        'Clique abaixo e iremos analisar sua solicitação de aumento de limite, e nosso time entrará em contato o mais rápido possível.' : 'Nosso time entrará em contato o mais rápido possível.'
       }}
        </p>

        <div class="mt-5">
          <bfd-button
            [text]="view === 'limit-increase' ? 'Quero aumentar meu limite' : 'Fechar'"
            [loading]="false"
            [disabled]="false"
            [type]="'primary-wide'"
            (buttonClick)="limitIncrease($event)"
          ></bfd-button>
        </div>
      </ng-container>
      <ng-container *ngIf="view === 'simulator-limit-use' || view === 'simulator-result'">
        <ng-container *ngIf="view === 'simulator-limit-use'">
          <p class="text-base">
            Informe abaixo quanto do seu limite você pretende usar e por quanto tempo.
          </p>
          <div class="d-flex flex-column mb-3">
            <label>Valor*</label>
            <input
              type="text"
              [(ngModel)]="value"
              class="form-input"
              maxlength="18"
              currencyMask
              [options]="{
                prefix: 'R$ ',
                thousands: '.',
                decimal: ',',
                align: 'left',
                allowNegative: false,
                allowZero: false
              }"
              placeholder="R$ 0,00"
            />
          </div>
  
          <div class="d-flex flex-column mb-3">
            <label>Dia inicial*</label>
            <fibra-datepicker
              class="fibra-datepicker-custom"
              [maxDate]="maxDate"
              placement="top"
              [minDate]="minDate"
              [date]="date"
              (dateSelected)="dateSelect($event)"
            >
            </fibra-datepicker>
          </div>
  
          <div class="d-flex flex-column mb-2">
            <label>Dia Final*</label>
            <fibra-datepicker
              class="fibra-datepicker-custom"
              [maxDate]="maxDateFinal"
              placement="top"
              [minDate]="minDateFinal"
              [date]="dateFinal"
              (dateSelected)="dateSelectFinal($event)"
            >
            </fibra-datepicker>
            <span class="span-description color-gray mt-2">
              Máximo 30 dias após o dia inicial
            </span>
          </div>
        </ng-container>
        <ng-container *ngIf="view === 'simulator-result'">
          <p class="text-base">
            Informe abaixo quanto do seu limite você pretende usar e por quanto tempo.
          </p>
          <div class="d-flex flex-column mb-3">
            <span class="span-description">Período</span>
            <span class="span-value">24/03/2025 até 24/04/2025</span>
          </div>
          <div class="d-flex flex-column mb-3">
            <span class="span-description">Valor simulado</span>
            <span class="span-value">R$ 1.000,00</span>
          </div>
          <div class="d-flex flex-column mb-3">
            <span class="span-description">Juros</span>
            <span class="span-value">R$ 55,11</span>
          </div>
          <div class="d-flex flex-column mb-3">
            <span class="span-description">IOF</span>
            <span class="span-value">R$ 5,27</span>
          </div>
          <div class="d-flex flex-column mb-3">
            <span class="span-description">Total a pagar</span>
            <span class="span-value">R$ 1.060,38</span>
          </div>
        </ng-container>

        <div class="d-flex flex-column mt-5">
          <bfd-button
            [text]="view == 'simulator-limit-use' ? 'Simular' : 'Simular novamente'"
            [disabled]="value == 0 || value == null"
            [loading]="false"
            [type]="'primary-wide'"
            (buttonClick)="sendSimulation($event)"
          ></bfd-button>
          <bfd-button
            class="mt-3"
            [text]="view == 'simulator-limit-use' ? 'Voltar' : 'Fechar'"
            [loading]="false"
            [disabled]="false"
            (buttonClick)="sendSimulation($event)"
            [type]="'secondary-wide'"
          ></bfd-button>
        </div>

        <bfd-divider *ngIf="alertBottom" [type]="'line'" [padding]="'medium'"></bfd-divider>
        <div *ngIf="alertBottom" class="alert">
          <img [src]="'../../../../assets/svg/info-simulator.svg'" />
          <p>{{ alertBottom }}</p>
        </div>
      </ng-container>
      <ng-container *ngIf="view === 'blocked-balance'">
        <p class="text-base">
          Para saber mais informações sobre o seu saldo bloqueado entre em contato com nosso atendimento. Caso prefira,  clique abaixo entramos em contato o mais breve possível.
        </p>
        <div class="d-flex flex-column mt-2">
          <span class="span-value-blocked">Corporate, Agro, Middle e PMEs</span>
          <span class="span-description-blocked">(11) 4130-7449</span>
          <a class="span-description-blocked" href="mailto:relacionamento@bancofibra.com.br">relacionamento@bancofibra.com.br</a>
          <p class="p-description-blocked">Horário: 9h às 18h, de segunda a sexta-feira, exceto feriados.</p>
        </div>
      </ng-container>
      <ng-container *ngIf="view === 'duplicate-linked-account'">
        <p class="text-base">
          O saldo é composto pela soma das garantias e da conveniência aprovada.
        </p>
        <div class="d-flex flex-column mt-2">
          <p class="text-base">O valor disponível ou indisponível pode mudar ao longo do dia, conforme a apuração das garantias e a análise de crédito diária.</p>
          <p class="text-base mb-0">A disponibilidade está sujeita às obrigações contratuais.</p>
          <bfd-divider [type]="'line'" [padding]="'medium'"></bfd-divider>
          <p class="text-base">Para saber mais informações sobre seus valores entre em contato com seu gerente.</p>
        </div>
      </ng-container>
      <ng-container *ngIf="view === 'detail-statement'">
        <p class="text-base">
            {{ content.nomeContraparte ? this.content.nomeContraparte : content.nome_favorecido }}
          </p>
          <div class="d-flex flex-column mb-3">
            <span class="span-description">Data</span>
            <span class="span-value">{{ content.dataLancto ?  content.dataLancto : ( content.data | date: 'dd/MM/yyyy') }}</span>
          </div>
          <div class="d-flex flex-column mb-3">
            <span class="span-description">Valor</span>
            <span class="span-value">{{ content.valorLcto ? (content.valorLcto | currency : "BRL") : (content.vlr_lancamento | currency : "BRL") }}</span>
          </div>
          <div class="d-flex flex-column mb-3">
            <span class="span-description">Tipo de transação</span>
            <span class="span-value">{{ content.natureza ? content.natureza : content.desc_historico }}</span>
          </div>
          <bfd-divider [padding]="'medium'"></bfd-divider>
          <bfd-button
            [text]="'Imprimir comprovante'"
            [loading]="false"
            [disabled]="false"
            [type]="'primary-wide'"
            (buttonClick)="downloadReceipt(content.cod_lancamento ? content.cod_lancamento : 0)"
          ></bfd-button>
          <bfd-divider [padding]="'small'"></bfd-divider>
          <bfd-button
            [text]="'Fechar'"
            [loading]="false"
            [disabled]="false"
            [type]="'secondary-wide'"
            (buttonClick)="close()"
          ></bfd-button>
      </ng-container>
    </div>

    <div class="popover-footer"></div>
  </div>
</div>
